@if (showNoData) {
    <div class="no-data">{{ 'testscoreChart.noDataFound' | t }}</div>
} @else {
    @if (!loadedChart) {
        <div class="fancy-loader submodule"></div>
    }
}
<div #chart></div>
